import { initialState } from 'hooks/reducers/GlobalReducer';
import React from 'react';
import { GlobalContextType } from 'types';

const globalContext: GlobalContextType = {
  // All Available Taxonomy Values for the site
  activeExperiment: initialState.activeExperiment,
  microSiteTaxonomyMap: initialState.microSiteTaxonomyMap,
  programTaxonomyMap: initialState.programTaxonomyMap,
  sessionInfo: initialState.sessionInfo,
  questionnaire: {
    schoolCode: '',
    variant: '',
    id: 0,
    stepsCount: 0,
    steps: [],
    useLandingPageHeadline: false,
    isFullPage: false,
    hasDynamicDisclaimer: false,
    customButtonText: {
      disclaimer: '',
      first: '',
      last: '',
    },
  },
  // Page Level Taxonomy Values
  taxonomyValues: {
    degrees: [],
    parentCategories: [],
    categories: [],
    programs: [],
  },
  flags: initialState.flags,
  userData: initialState.userData,
  refs: {
    heroRef: null,
    headerRef: null,
    modalContainerRef: null,
    clickPortalSearchResultsRef: null,
    themeWrapperRef: null,
  },
  resumeModal: {
    isOpen: false,
  },
  actions: {
    updateGlobalFlags: () => null,
    setActiveModalId: () => null,
    updateUserData: () => null,
    updateMicroPortalData: () => null,
    updateGlobalRefs: () => null,
    updateClickPortalData: () => null,
  },
  windowSize: initialState.windowSize,
  clickPortal: initialState.clickPortal,
  formSettings: initialState.formSettings,
  microPortal: initialState.microPortal,
  siteMeta: {
    domain: '',
    googleTagManagerSiteId: '',
    robots: '',
    siteDescription: '',
    siteName: '',
    schoolCode: '',
    theme: '',
    canonicalDomain: '',
    ketch: {
      isEnabled: false,
      propertyId: '',
    },
    favicon: '',
    isDraftMode: false,
    isABTestingEnabled: false,
    disclosure: '',
    disclaimerSuccessText: '',
    floodlightActivityValues: {
      eventValues: [],
    },
    sharedDisclaimerOptInText: '',
    disclaimerText: '',
    siteType: '',
    clickPortalSettings: {
      isMultiRow: false,
      secondaryNavItems: [],
      secondaryNavLabel: '',
    },
  },
};

const GlobalContext = React.createContext(globalContext);

export default GlobalContext;
